import { withInstall } from '@antdv/utils';
import AApp from './src/App';

export const App = withInstall(AApp);

export default App;

export * from './src/interface';
export * from './src/props';
